import { render, staticRenderFns } from "./SensorLanding.html?vue&type=template&id=4980b2de&scoped=true&"
import script from "./SensorLanding.vue?vue&type=script&lang=js&"
export * from "./SensorLanding.vue?vue&type=script&lang=js&"
import style0 from "./SensorLanding.vue?vue&type=style&index=0&id=4980b2de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4980b2de",
  null
  
)

export default component.exports